import React, { useRef, useState } from "react";
import { Mic, Square, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

// Dettatura vocale: registra, trascrive e passa il testo a onText
export function MicButton({ onText, testid = "mic-btn" }) {
  const [rec, setRec] = useState(false);
  const [busy, setBusy] = useState(false);
  const mr = useRef(null);
  const chunks = useRef([]);
  const transcribe = async (blob) => {
    setBusy(true);
    try {
      const fd = new FormData(); fd.append("file", blob, "dettatura.webm");
      const { data } = await api.post("/note/trascrivi", fd);
      if (data.text) onText(data.text); else toast.info("Nessun parlato rilevato");
    } catch { toast.error("Trascrizione non riuscita"); }
    setBusy(false);
  };
  const start = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const r = new MediaRecorder(stream); chunks.current = [];
      r.ondataavailable = (e) => { if (e.data.size) chunks.current.push(e.data); };
      r.onstop = () => { stream.getTracks().forEach((t) => t.stop()); transcribe(new Blob(chunks.current, { type: "audio/webm" })); };
      r.start(); mr.current = r; setRec(true);
    } catch { toast.error("Microfono non disponibile o permesso negato"); }
  };
  const stop = () => { if (mr.current && mr.current.state !== "inactive") mr.current.stop(); setRec(false); };
  return (
    <button type="button" onClick={rec ? stop : start} disabled={busy} title={rec ? "Ferma e trascrivi" : "Detta a voce"} data-testid={testid}
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-semibold border transition-colors ${rec ? "bg-red-600 text-white border-red-600 animate-pulse" : "bg-white hover:bg-secondary"}`}>
      {busy ? <Loader2 size={13} className="animate-spin" /> : rec ? <Square size={12} /> : <Mic size={13} />} {busy ? "Trascrivo…" : rec ? "Stop" : "Detta"}
    </button>
  );
}
